@if (disclaimer && contentItems.length > 0) {
  <div class="footer-disclaimer-container" [class.footer-disclaimer-container--full-width]="fullWidth">
    @for (item of contentItems; track item; let i = $index) {
      <p class="c11n-text-sm" [class.footer-disclaimer-item]="i > 0" [innerHTML]="item"></p>
    }
  </div>
}
